import { client } from './client'

const getExecutivesService = async (cocap: string) => {
  const { data } = await client.get('/person/executives', {
    headers: {
      cocap
    }
  })
  return data
}

const getExecutiveCasesService = async (cocap: string, executiveId: string) => {
  const { data } = await client.get(`/executive/cases?executiveId=${executiveId}`, {
    headers: {
      cocap
    }
  })
  return data
}

export { getExecutivesService, getExecutiveCasesService }
